// GraphQL queries and mutations for Minew Testing Tool

import { gql } from '@apollo/client';

export const ROOMS_QUERY = gql`
  query rooms {
    rooms {
      id
      name
      type
    }
  }
`;

export const GATEWAYS_QUERY = gql`
  query gateways {
    gateways {
      id
      type
      threshold
      room {
        id
        name
        type
      }
    }
  }
`;

export const BRACELETS_QUERY = gql`
  query bracelets {
    bracelets {
      id
      batteryLevel
      updatedAt
    }
  }
`;

export const PHYSICIANS_QUERY = gql`
  query physicians {
    physicians {
      id
      name
    }
  }
`;

export const PROCEDURE_TYPES_QUERY = gql`
  query procedureTypes {
    procedureTypes {
      id
      name
    }
  }
`;

export const OPERATION_ROOMS_QUERY = gql`
  query operationRooms {
    rooms: operationRooms {
      id
      name
      type
    }
  }
`;

export const PATIENTS_QUERY = gql`
  query patients {
    patients {
      id
      name
      braceletId
      status
      room {
        id
        name
      }
    }
  }
`;

export const EDIT_GATEWAY = gql`
  mutation editGateway($id: String!, $gatewayType: GatewayType, $roomId: Long, $threshold: Int) {
    editGateway(id: $id, gatewayType: $gatewayType, threshold: $threshold, roomId: $roomId)
  }
`;

export const CREATE_PATIENT = gql`
  mutation createPatient($name: String, $braceletId: String!, $physician: Long!, $procedureType: Long) {
    createPatient(name: $name, braceletId: $braceletId, physician: $physician, procedureType: $procedureType) {
      id
      name
      braceletId
    }
  }
`;

export const EDIT_PATIENT = gql`
  mutation editPatient($id: Long!, $braceletId: String) {
    editPatient(id: $id, braceletId: $braceletId) {
      id
      name
      braceletId
    }
  }
`;

// Staff queries and mutations
export const STAFF_QUERY = gql`
  query staff {
    staff {
      id
      staffId
      name
      bracelet {
        id
      }
    }
  }
`;

export const EDIT_STAFF = gql`
  mutation editStaff($id: Long!, $name: String!, $braceletId: String) {
    editStaff(id: $id, name: $name, braceletId: $braceletId) {
      id
      name
      bracelet {
        id
      }
    }
  }
`;

// Physicians query with bracelet
export const PHYSICIANS_WITH_BRACELET_QUERY = gql`
  query physiciansWithBracelet {
    physicians {
      id
      name
      bracelet {
        id
      }
    }
  }
`;

export const EDIT_PHYSICIAN = gql`
  mutation editPhysician($id: Long!, $name: String!, $braceletId: String) {
    editPhysician(id: $id, name: $name, braceletId: $braceletId) {
      id
      name
      bracelet {
        id
      }
    }
  }
`;

// Anesthesiologists queries and mutations
export const ANESTHESIOLOGISTS_QUERY = gql`
  query anesthesiologists {
    anesthesiologists {
      id
      name
      bracelet {
        id
      }
    }
  }
`;

export const EDIT_ANESTHESIOLOGIST = gql`
  mutation editAnesthesiologist($id: Long!, $name: String!, $braceletId: String) {
    editAnesthesiologist(id: $id, name: $name, braceletId: $braceletId) {
      id
      name
      bracelet {
        id
      }
    }
  }
`;
